<template>
  <router-link
    :to="props.to"
    :disabled="props.disabled || props.pending"
    :class="[
      'text-md py-2 px-5 border font-regular rounded-lg focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:bg-opacity-50 disabled:pointer-events-none flex items-center w-full',
      getButtonStyle(props.styleType),
    ]"
  >
    <Spinner :horizontal="true" v-if="pending" :custom-text="pendingText" />
    <i
      v-if="iconPosition === 'left' && icon"
      :class="'fas fa-' + icon + ' mr-2'"
    ></i>
    <span class="truncate" v-if="!pending">{{ text }} </span>
    <i
      v-if="iconPosition !== 'left' && icon"
      :class="'fas fa-' + icon + ' ml-2'"
    ></i>
  </router-link>
</template>

<script setup lang="ts">
import { defineProps } from "vue";
import Spinner from "./Spinner.vue";
import { getButtonStyle } from "@/utils/buttonStyle";

const props = defineProps<{
  styleType?:
    | "primary"
    | "secondary"
    | "cancel"
    | "accent"
    | "like"
    | "cta"
    | "green";
  text: string;
  icon?: string;
  iconPosition?: "left" | "right";
  pending?: boolean;
  pendingText?: string;
  disabled?: boolean;
  to: {
    name: string;
    params?: Record<string, string | number>;
    query?: Record<string, string | number>;
  };
}>();
</script>
